<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Período:"
    id="selectPeríodo"
    placeholder="Selecione o Período"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import KmValueRepository from '@/shared/http/repositories/configurations/kmvalue.js'

export default {
  name: 'NxSelectKMPeriodo',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadKmValue()
  },
  methods: {
    onLoadKmValue () {
      KmValueRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': `${x.dataInicial} - ${x.dataFinal}`}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de períodos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectKMPeriodo.vue